<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Desktop Sidebar Navigation (>= 1024px) - Only show when authenticated and not on public routes -->
    <SidebarNavigation v-if="isAuthenticated && !isPublicRoute" />

    <!-- Main Content Area -->
    <div :class="isAuthenticated && !isPublicRoute ? 'lg:pl-64' : ''">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import SidebarNavigation from '@/components/SidebarNavigation.vue'

const route = useRoute()
const authStore = useAuthStore()

// Check if user is authenticated
const isAuthenticated = computed(() => !!authStore.user)

// Check if current route is public (landing, login, signup)
const isPublicRoute = computed(() => {
  const publicRoutes = ['/', '/login', '/signup']
  return publicRoutes.includes(route.path)
})

onMounted(async () => {
  // Initialize Firebase auth listener
  await authStore.initAuth()
})
</script>
